module.exports = __webpack_public_path__ + "static/person-64922b2b9a69a0736abb9f6cb414aa6b.png";